import React, { useEffect, useState } from "react";
import AccountScreen from "./AccountScreen";
import AccountScreenMobile from "./AccountScreenMobile";

export default function ResponsiveAccountScreen() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile ? <AccountScreenMobile /> : <AccountScreen />;
}